import { validateResponseHasSchema } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { creditNoteDetailedSchema } from '@/features/invoices/models/schemas/credit-notes'

const client = createAssetManagementClient()

export const getAllocatableCreditNotes = (invoiceId: number) => validateResponseHasSchema(
  client.sendGet(`billing/invoices/${invoiceId}/credit-notes`),
  z.object({
    data: z.array(creditNoteDetailedSchema)
  })
).then(
  res => res.data
);
